export default __webpack_public_path__ + "static/media/news43.cd725805.jpg";